import * as actionTypes from './actionTypes';

export const cancelSubscriptionRequest = (payload) => ({ type: actionTypes.PAYMENT_CANCEL_SUBSCRIPTION_REQUEST, payload });
export const cancelSubscriptionError = (payload) => ({ type: actionTypes.PAYMENT_CANCEL_SUBSCRIPTION_ERROR, payload });
export const cancelSubscriptionSuccess = (payload) => ({ type: actionTypes.PAYMENT_CANCEL_SUBSCRIPTION_SUCCESS, payload });

export const buySubscriptionRequest = (payload) => ({ type: actionTypes.PAYMENT_BUY_SUBSCRIPTION_REQUEST, payload });
export const buySubscriptionError = (payload) => ({ type: actionTypes.PAYMENT_BUY_SUBSCRIPTION_ERROR, payload });
export const buySubscriptionSuccess = (payload) => ({ type: actionTypes.PAYMENT_BUY_SUBSCRIPTION_SUCCESS, payload });

export const resetPaymentState = () => ({ type: actionTypes.PAYMENT_RESET_STATE });
